// [CurveBeam] - [BoneVue]

// Not yet used, will leave for now
export class GetMeasurementsResponse {
  // The image series ID, stored in the AWS healthimaging
  // Please make sure the original study stored in the same datastore
  seriesId: string;

  // S3 signed URL
  url: string;
}